import { useClassNames, useOverflow } from '@magnetic/hooks';
import { CaretRight } from '@magnetic/icons';
import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const CaretChildren = /* @__PURE__ */ __name(({
  children: [first, ...rest],
  visibleItems
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("li", {
  className: "mds-rebuild-breadcrumb-item"
}, first), visibleItems < rest.length && /* @__PURE__ */ React.createElement("div", {
  className: "mds-rebuild-breadcrumb-item"
}, /* @__PURE__ */ React.createElement(CaretRight, {
  size: 16,
  weight: "bold"
}), "\u2026"), rest.slice(-visibleItems).map((current) => /* @__PURE__ */ React.createElement("li", {
  className: "mds-rebuild-breadcrumb-item",
  key: typeof current !== "string" && typeof current !== "number" && "key" in current ? current.key : current.toString()
}, /* @__PURE__ */ React.createElement(CaretRight, {
  color: "var(--interact-icon-weak-default)",
  size: 16,
  weight: "bold"
}), current))), "CaretChildren");
const BreadcrumbMultiple = /* @__PURE__ */ __name(({
  children,
  className,
  ...rest
}) => {
  const classNames = useClassNames("mds-rebuild-breadcrumb", className);
  const { childArray, ref, visibleItems } = useOverflow(
    children,
    ".mds-rebuild-breadcrumb-item"
  );
  return /* @__PURE__ */ React.createElement("nav", {
    className: classNames,
    ...rest,
    ref
  }, /* @__PURE__ */ React.createElement("ul", null, /* @__PURE__ */ React.createElement(CaretChildren, {
    visibleItems
  }, childArray)));
}, "BreadcrumbMultiple");

export { BreadcrumbMultiple };
//# sourceMappingURL=breadcrumb-multiple.js.map
